import React from 'react'
import styles from './EdofSection11.module.css'
const EdofSection11 = () => {
    return (
        <div className={styles.containerBox}>
            <div className={styles.container}>
                <div className={styles.LeftSide}>

                </div>
                <div className={styles.RightSide}>
                    <img src='/Images/deseyne_logo_text.webp' alt='deseyne_logo_text' />
                </div>
            </div>
        </div>
    )
}

export default EdofSection11
